export default {
  back: {
    placeholderCopy: 'Flip card over and tap button below to capture the back of card.',
    title: 'Back of ID card',
  },
  header: {
    subtitle:
      "Please upload a driver's license or other government issued ID so the doctor can verify they're seeing the right person.",
    title: "Add photos of the patient's ID",
  },
  ctaButton: {
    continue: 'Continue',
  },
  placeholder: {
    uploadButton: 'Take a photo',
  },
  front: {
    title: 'Front of ID card',
    placeholderLineOne: 'Place card on a flat, well-lit surface',
    placeholderLineTwo: '(no glare) and tap button below.',
  },
};
